import FEATURES_CONFIG from 'config/features';

import { isFunction, isNonEmptyObject } from 'utils/helpers.util';
import {
  DELIVER_TO_PUT_ADDRESS_API,
  DELIVER_TO_PUT_ADDRESS_COOKIE_API,
  DELIVER_TO_PUT_ADDRESS_API_SPLIT_PAYMENT,
  DELIVER_TO_PUT_ADDRESS_API_SPLIT_PAYMENT_CHECKOUT_TYPE,
  DELIVER_TO_PUT_ADDRESS_API_CHECKOUT_TYPE,
} from '../../constants/apis.constant';

import { IAddress, IDeliveryArea } from 'services/user/types/user.types';
import {
  EApiMiddlewareMethods,
  TApiMiddlewareDispatch,
} from 'config/redux/middlewares/api.middleware.types';

import {
  EDeliverToActionTypes,
  IDeliverTo,
  TDeliverToAction,
  TDeliverToDispatch,
} from 'pages/Checkout/types/deliverTo.types';

import { fetchCartAction } from 'pages/Cart/redux/actions/getCart.action';

import { fetchCartAction as V3FetchCartAction } from 'pages/NewCart/redux/actions/fetchCart.actions';

import { TScreenDispatch } from 'pages/Checkout/types/screen.types';
import { setScreenToHide } from 'pages/Checkout/redux/actions/screen.actions';

import { IAppState } from 'config/redux/reducers';
import { batch } from 'react-redux';
import { CookieUtils, setAreaCode } from '@mafc/common';
import APP_CONFIG from 'config/App.config';
import { newFetchCartAction } from 'pages/Cart/redux/actions/newCart.actions';
import { checkoutType, getAreaCode, getCartId } from 'pages/Cart/helpers/url.helpers';
import isPaymentV2Enabled from 'pages/Checkout/components/Payment/helpers/isPaymentV2Enabled';
import { resetSlots } from 'common/DeliverySlot/redux/deliverySlot.action';
import { createGrowthBookInstance } from '@mafc/appshell';
import { extractErrorProps, getErrorMessage } from 'utils/error.util';
import { initStorageManager } from 'utils/customStorage.util';
import history from 'routes/customHistory';
import { VALIDATE_ADDRESS_ERROR } from 'pages/NewCart/constants/cart.constants';
import { isInvalidAddress } from 'pages/Checkout/helpers/deliveryAction.helper';
import { GROWTHBOOK_FLAGS } from 'pages/NewCart/constants/growthbook.constants';
import { getCartPageUrl } from 'utils/cartRevamp.util';
import { getAvailableServiceTypes } from 'pages/Cart/helpers/getServiceType.helper';
const storage = initStorageManager(() => sessionStorage);

export const setDeliverToLoading = (loading: IDeliverTo['loading']): TDeliverToAction => ({
  type: EDeliverToActionTypes.DELIVER_TO_SET_LOADING,
  payload: { loading },
});

export const setDeliverToCache = (cache: IDeliverTo['cache']): TDeliverToAction => ({
  type: EDeliverToActionTypes.DELIVER_TO_SET_CACHE,
  payload: { cache },
});

export const setDeliverToValue = (value: IDeliverTo['value']): TDeliverToAction => ({
  type: EDeliverToActionTypes.DELIVER_TO_SET_VALUE,
  payload: { value },
});

export const resetDeliverTo = (): TDeliverToAction => ({
  type: EDeliverToActionTypes.DELIVER_TO_RESET_VALUE,
  payload: {},
});

export const setDeliverToError = (error: IDeliverTo['error']): TDeliverToAction => ({
  type: EDeliverToActionTypes.DELIVER_TO_SET_ERROR,
  payload: { error },
});

export const deliverToPutAddress = (
  address: IAddress,
  callback?: () => void,
  setCookie = FEATURES_CONFIG.settings.changeLocation
) => (dispatch: TApiMiddlewareDispatch & TDeliverToDispatch, getState: () => IAppState) => {
  // clear all previous errors
  const store = getState();
  const { countryConfiguration = {}, storeId = '', language = '' } = store.appConfig || {};
  const { isSingleUseBagsSupported = false } = countryConfiguration.cart || {
    isSingleUseBagsSupported: false,
  };
  const isPackageFreeDelivery =
    isSingleUseBagsSupported && CookieUtils.getPackageFreeDelivery() !== ''
      ? CookieUtils.getPackageFreeDelivery()
      : '';
  dispatch(setDeliverToError(''));
  dispatch(setDeliverToLoading(true));
  const { pv } = store.checkout.paymentArchitecture;
  const isWebPaymentArchitectureV2Enabled = isPaymentV2Enabled(store);
  let url = isWebPaymentArchitectureV2Enabled
    ? DELIVER_TO_PUT_ADDRESS_API_SPLIT_PAYMENT
    : DELIVER_TO_PUT_ADDRESS_API;

  const growthbook = createGrowthBookInstance(
    {
      ...store.appConfig.growthBook,
    },
    store
  );
  const { value } = growthbook.feature('new_carrefour_journey');
  const isCartBundlingEnabled = growthbook.feature('common.cart_bundling.enabled').on;
  const isCartRevampEnabled = growthbook.feature(GROWTHBOOK_FLAGS.CART_REVAMP_ENABLED).on;
  const nsp = getAvailableServiceTypes(getState, growthbook);
  const stcl = growthbook.feature('common.store_close_services.enabled').on || false;
  const NEW_CART_PAGE = getCartPageUrl(storeId, language, isCartRevampEnabled);
  const { new_journey = false } = value || { new_journey: false };
  if (new_journey) {
    url = isWebPaymentArchitectureV2Enabled
      ? DELIVER_TO_PUT_ADDRESS_API_SPLIT_PAYMENT_CHECKOUT_TYPE
      : DELIVER_TO_PUT_ADDRESS_API_CHECKOUT_TYPE;
  }
  if (pv) {
    url += `&payment_arch=${pv}`;
  }
  if (isCartBundlingEnabled) {
    url += '&cp=true';
  }
  dispatch({
    type: EDeliverToActionTypes.DELIVER_TO_PUT_ADDRESS,
    payload: {
      enableProgress: false,
      onSuccess: () => {
        batch(() => {
          if (setCookie) {
            if (!store.appConfig.features.isLocationCXEnable) {
              dispatch(deliverToPutAddressCookie(address, callback) as any);
              dispatch(setAreaCode(getAreaCode(getState(), address)));
            }
            dispatch(deliverToPutAddressUpdateCart(address as IAddress) as any);
          } else {
            // dispatch(setDeliverToLoading(false));
            dispatch(deliverToPutAddressUpdateCart(address) as any);
          }
          dispatch(setDeliverToValue(address));
          dispatch(resetSlots() as any);
        });
      },
      onFailure: (apiErrMsg: any, apiEr: any) => {
        const { errorCode } = extractErrorProps(apiEr);
        const message = getErrorMessage(apiEr);
        if (isInvalidAddress(errorCode)) {
          storage.setItem(VALIDATE_ADDRESS_ERROR, errorCode);
          if (isCartRevampEnabled) {
            window.location.href = NEW_CART_PAGE;
          } else {
            history.push(NEW_CART_PAGE);
          }
        }
        batch(() => {
          dispatch(setDeliverToError(message || apiErrMsg));
          dispatch(setDeliverToLoading(false));
        });
      },
      method: EApiMiddlewareMethods.PUT,
      params: {
        checkoutType: checkoutType() || '',
        addressId: address.id,
        areacode: getAreaCode(store, address),
        isNewCartService: APP_CONFIG.isNewEndpoint,
        cartId: getCartId(store),
        sustainabilityConsent: isPackageFreeDelivery,
        stcl,
        nsp,
      },
      url,
    },
  });
};

export const deliverToPutAddressUpdateCart = (address: IAddress) => (
  dispatch: any,
  getState: () => IAppState
) => {
  const hasCart = window.location.href.indexOf('/cart') !== -1;
  const successCallback = () => {
    // at every time successCallback executes we need to read currentStore
    // WE WILL REMOVE THIS COMMENT ONCE PR MERGED WITH MASTER
    // const currentStore = getState();
    // const hasStandardFood = isNonEmptyArray(
    //   extractShipment(currentStore.shipments, EShipmentTypes.STANDARD_FOOD).entries
    // );
    batch(() => {
      // if (hasStandardFood) {
      //   dispatch(
      //     fetchSelectedSlot(getAreaCode(currentStore, address), getCartId(currentStore)) as any
      //   );
      // }

      dispatch(setDeliverToLoading(false));
      dispatch(setScreenToHide());
    });
  };

  const store = getState();

  const growthbook = createGrowthBookInstance(
    {
      ...store.appConfig.growthBook,
    },
    store
  );
  const { value } = growthbook.feature('new_carrefour_journey');
  const { new_journey = false } = value || { new_journey: false };
  if (store.cart && store.cart.cartData && isNonEmptyObject(store.cart.cartData)) {
    successCallback();
  } else {
    // api calls when page reloads
    if (APP_CONFIG.isNewEndpoint) {
      // Only for checkout page for new cart service
      if (!hasCart) {
        // true for new cart v3 is called
        new_journey
          ? dispatch(V3FetchCartAction(successCallback, undefined, true))
          : dispatch(newFetchCartAction(successCallback));
      }
    } else {
      // Everytime for Hybris cart
      dispatch(fetchCartAction(successCallback));
    }
  }
};

export const deliverToPutAddressCookie = (
  address: { deliveryArea: IDeliveryArea; [key: string]: any },
  callback?: () => void
) => (
  dispatch: TApiMiddlewareDispatch & TDeliverToDispatch & TScreenDispatch,
  getState: () => IAppState
) => {
  const store = getState();
  dispatch({
    type: EDeliverToActionTypes.DELIVER_TO_PUT_ADDRESS_COOKIE,
    payload: {
      enableProgress: false,
      onSuccess: () => {
        if (callback && isFunction(callback)) {
          callback();
        } else {
          dispatch(setAreaCode(getAreaCode(getState(), address)));
          dispatch(deliverToPutAddressUpdateCart(address as IAddress) as any);
        }
      },
      // onFinally: () => dispatch(setDeliverToLoading(false)),
      onFailure: (apiErrMsg: any, apiEr: any) => {
        const message = ((((apiEr.response || {}).data || {}).errors || [])[0] || {}).message;
        dispatch(setDeliverToError(message || apiErrMsg));
      },
      method: EApiMiddlewareMethods.PUT,
      params: {
        areacode: getAreaCode(store, address),
      },
      url: DELIVER_TO_PUT_ADDRESS_COOKIE_API,
    },
  });
};
